import { VWMap } from '../VattenwebbMap';
import '../libs/leaflet.canvas-markers';
import { autorun } from 'mobx';

import lakeMapIcon from '../../img/map_icon.png';

import STATE from '../app/state.js';

function ajax(url, options) {
    document.body.classList.add('waiting');
    return $.ajax(url, options)
    .always(function () {
        document.body.classList.remove('waiting');
    });
}

function lteFilter(param, value) {
    return ''
    + '<PropertyIsLessThanOrEqualTo>'
    + `    <PropertyName>${param}</PropertyName>`
    + `    <Literal>${value}</Literal>`
    + '</PropertyIsLessThanOrEqualTo>';
}

function gteFilter(param, value) {
    return ''
    + '<PropertyIsGreaterThanOrEqualTo>'
    + `    <PropertyName>${param}</PropertyName>`
    + `    <Literal>${value}</Literal>`
    + '</PropertyIsGreaterThanOrEqualTo>';
}

// åäöÅÄÖ doesn't work with Mapserver < 7
function like(param, value) {
    const str = value.replace(/[åäöÅÄÖ]/g, '.');
    return ''
    + '<PropertyIsLike wildcard="*" singleChar="." escape="!">'
    + `    <PropertyName>${param}</PropertyName>`
    + `    <Literal>${str}</Literal>`
    + '</PropertyIsLike>';
}

function eq(param, value) {
    return ''
    + '<PropertyIsEqualTo>'
    + `    <PropertyName>${param}</PropertyName>`
    + `    <Literal>${value}</Literal>`
    + '</PropertyIsEqualTo>';
}

function neq(param, value) {
    return ''
    + '<PropertyIsNotEqualTo>'
    + `    <PropertyName>${param}</PropertyName>`
    + `    <Literal>${value}</Literal>`
    + '</PropertyIsNotEqualTo>';
}

function or(filters) {
    return `<OR>${filters.join('')}</OR>`;
}
function and(filters) {
    return `<AND>${filters.join('')}</AND>`;
}

function interval(param, from, to, miss) {
    if(from || to) {
        let tmp = [];
        if(from) {
            tmp.push(and([gteFilter(param, from), neq(param, '0')]))
        }
        if(to) {
            tmp.push(and([lteFilter(param, to), neq(param, '0')]))
        }
        
        if(tmp.length == 2) {
            tmp = [and(tmp)];
        }
        
        if(miss) {
            tmp.push(eq(param, '0'));
        }
        
        if(tmp.length == 2) {
            return or(tmp);
        } else {
            return tmp.join('');
        }
    } else {
        return '';
    }
}

function createDamSldFilter(damFilter) {
    const miss = damFilter.includeMissingValues;
    
    let filters = [];
    if(damFilter.county) {
        // There are no dams with missing INRAPP_LST
        // and how SVAR would represent that is unknown
        filters.push(like('INRAPP_LST', damFilter.county));
    }
    
    filters.push(interval('RV', damFilter.volume.from, damFilter.volume.to, miss));
    filters.push(interval('MY', damFilter.surfaceArea.from, damFilter.surfaceArea.to, miss));
    filters.push(interval('BYGGAR', damFilter.year.from, damFilter.year.to, miss));
    
    const fs = filters.filter(f => f.length > 0);
    let filter = '';
    if(fs.length > 1) {
        filter = and(fs);
    } else if (fs.length == 1) {
        filter = fs[0];
    } else {
        return '';
    }
    
    return `<Filter>${filter}</Filter>`;
}

function sld(filter) {
    return [
        '<StyledLayerDescriptor version="1.1.0">',
        '<NamedLayer>',
        '    <Name>dammprod</Name>',
        '    <UserStyle>',
        '        <FeatureTypeStyle>',
        '            <Rule>',
        filter,
        '                <PointSymbolizer>',
        '                    <Graphic>',
        '                        <Size>4</Size>',
        '                        <Mark>',
        '                            <Stroke>',
        '                                <CssParameter name="stroke">#000000</CssParameter>',
        '                            </Stroke>',
        '                            <Fill>',
        '                                <CssParameter name="fill">#ff0000</CssParameter>',
        '                            </Fill>',
        '                        </Mark>',
        '                    </Graphic>',
        '                </PointSymbolizer>',
        '            </Rule>',
        '        </FeatureTypeStyle>',
        '    </UserStyle>',
        '</NamedLayer>',
        '</StyledLayerDescriptor>'
    ].map(s => s.trim()).join('');
}

const SvarMap = VWMap.extend({
    options: {
        center: new L.LatLng(61.93971314997426, 16.54225424576134), //Almost center Sweden.
        zoom: 2,
        //        zoomAnimation: true
    },
    
    initialize: function() {
        VWMap.prototype.initialize.call(this, 'map-container', this.options);
        
        this.lakePolygonLayer = L.layerGroup();
        this.lakeLayer = this.createLakeLayer();
        this.mapMarkers = L.canvasIconLayer({});
        // WMS layer for dams
        this.damLayer = this.createDamLayer();
        // Markers and polygons
        this.damMarkers = L.layerGroup();
        const self = this;
        this.mapMarkers.on("click", function (e) {
            map.clearLakes();
            ajax(`./rest/search/term`, {
                type: 'GET',
                traditional: true,
                data: { term: e.layer.options.sjoid, register: 'lake' },
                dataType: 'json'
            }).done(function (json) {
                map.addLakeFeature(json);
            });
        });
        this.mapMarkers.once('add', function () { self.getLakesWithMaps() });
        //        this.mapMarkers.once('add', function () { self.getDams() });
        this.showMapMarkers = false;
        this.mapIcon = L.icon({
            iconUrl: lakeMapIcon,
            iconSize: [16, 16],
            iconAnchor: [8,8]
        });
        
        autorun(() => {
            const feature = STATE.currentDam;
            if(feature === undefined) {
                return;
            }
            
            this.clearDams();
            const map = this;
            const geojson = L.geoJson(feature, {
                coordsToLatLng: function (coords) {
                    return map.options.crs.projection.unproject(new L.Point(coords[0], coords[1]));
                }
            });
            
            this.damMarkers.addLayer(geojson);
            this.showDamWaterArea(feature);
            this.setView(geojson.getBounds().getCenter(), 7);    
        })
        
        autorun(() => {
            const feature = STATE.currentLake;
            this.clearLakes();
            
            if(feature === undefined) {
                return;
            }
            
            const l = L.GeoJSON.geometryToLayer(feature, {
                coordsToLatLng: (coords) => {
                    return this.options.crs.projection.unproject(new L.Point(coords[0], coords[1]));
                }
            });
            l.setStyle({
                color: '#e91e63',
                fill: '#f48fb1'
            });
            l.feature = L.GeoJSON.asFeature(feature);
            this.lakePolygonLayer.addLayer(l);
            
            this.fitBounds(l.getBounds(), {
                padding: [5,5]
            });
        })
    },
    
    forceAddLayer(layer) {
        if(!this.hasLayer(layer)) {
            this.addLayer(layer);
        }
    },
    
    forceRemoveLayer(layer) {
        if(this.hasLayer(layer)) {
            this.removeLayer(layer);
        }
    },
    
    toggleMapMarkers: function (show) {
        this.showMapMarkers = show;
        if(show) {
            this.addLayer(this.mapMarkers);
        } else {
            this.removeLayer(this.mapMarkers);
        }
    },
    
    filterDams: function (damFilter) {
        const filter = createDamSldFilter(damFilter);
        if(filter.length == 0) {
            delete this.damLayer.wmsParams.SLD_BODY;
            this.damLayer.redraw();
        } else {
            this.damLayer.setParams({ SLD_BODY: sld(filter) });
        }
    },
    
    createLakeLayer: function () {
        var lakeLayer = new L.TileLayer.WMS(svarMapServer, {
            layers: 'lakes',
            FORMAT: 'image/png; mode=8bit',
            tileSize: 512,
            noWrap: true,
            transparent: true,
            name: 'Sjoregister'
        });
        return lakeLayer;
    },
    
    createDamLayer: function () {
        var damLayer = new L.TileLayer.WMS(svarMapServer, {
            layers: 'dammprod',
            FORMAT: 'image/png; mode=8bit',
            tileSize: 512,
            transparent: true,
            noWrap: true,
            name: 'Dammregister'
        });
        return damLayer;
    },
    
    getLakeInfo: function (lonlat) {
        var map = this;
        var point = this.options.crs.projection.project(lonlat);
        
        ajax(`./rest/click`, {
            type: 'GET',
            traditional: true,
            data: { lon: point.y, lat: point.x },
            dataType: 'json'
        }).done(function (json) { map.addLakeFeature(json) });
    },
    
    getDammInfo: function (latlng, filter) {
        var map = this;
        var point = map.options.crs.projection.project(latlng);
        ajax(`./rest/dammclick`, {
            type: 'GET',
            traditional: true,
            data: { lon: point.y, lat: point.x, filter: JSON.stringify(filter) },
            dataType: 'json'
        }).done(function (json) {
            if (!json.properties || json.properties.length == 0)
            return;
            
            map.addDamFeature(json);
        });
    },
    
    showDamWaterArea: function (feature) {
        var map = this;
        ajax(`./rest/dammclick/waterarea`, {
            type: 'GET',
            traditional: true,
            data: { eu_cd: feature.properties.EU_CD },
            dataType: 'json'
        }).done(function (json) {
            if (json) {
                L.geoJson(json, {
                    coordsToLatLng: function (coords) {
                        return map.options.crs.projection.unproject(new L.Point(coords[0], coords[1]));
                    },
                    style: {
                        color: '#e91e63',
                        fill: '#f48fb1'
                    }
                }).addTo(map.damMarkers);
            }
        });
    },
    
    addLakeFeature: function (feature) {
        function removeDuplicates(myArr, prop) {
            return myArr.filter(function (obj, pos, arr) {
                return arr.map(function (mapObj) { return mapObj[prop] }).indexOf(obj[prop]) === pos;
            });
        }
        
        if (feature !== undefined) {
            var p = feature.properties;
            if(p.Maps !== undefined) {
                p.Maps = removeDuplicates(p.Maps,"KARTNR");
            }
            
            if(p.Area === undefined) {
                let area = Math.round(p.AREA*10000)/10000;
                p.Area={Areal:area, info:' (kommande från SVAR_2016_3)'};
            }
        }
        STATE.currentLake = feature;
    },
    
    addDamFeature: function (feature) {
        STATE.currentDam = feature;
    },
    
    clearDams: function () {
        this.damMarkers.clearLayers();
    },
    
    clearLakes: function () {
        this.lakePolygonLayer.clearLayers();
    },
    
    getLakesWithMaps: function () {
        var map = this;
        
        ajax(`./rest/search/lakemaps`, {
            type: 'GET',
            traditional: true,
            dataType: 'json'
        }).done(function (json) {
            for (var key in json) {
                map.addLakeMapIcon(json[key]);
            }
            map.mapMarkers.redraw();
        });
    },
    
    getDams: function () {
        var map = this;
        
        //     	ajax('DAMM_PROD_2013_3.geojson', {
        //     		type: 'GET',
        //     		traditional: true,
        //     		dataType: 'json'
        //     	}).done(function (json) {
        //     		console.log('add dams');
        
        //     		var loader = new PIXI.loaders.Loader();
        //     		loader.add('marker', 'js/libs/leaflet-1.4.0/images/marker-icon.png');
        //     		loader.load(function (loader, resources)  {
        //     			const texture = resources.marker.texture;
        // 				const doubleBuffering = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        
        //     			const pixiLayer = (function () {
        //     				const pixiContainer = new PIXI.Container();
        //     				const innerContainer = new PIXI.particles.ParticleContainer(json.features.length, {vertices: true});
        //     				// add properties for our patched particleRenderer:
        //     				innerContainer.texture = texture;
        //     				innerContainer.baseTexture = texture.baseTexture;
        //     				innerContainer.anchor = {x: 0.5, y: 1};
        
        //     				pixiContainer.addChild(innerContainer);
        //     				let initialScale;
        //     				return L.pixiOverlay(function (utils, event) {
        //     					const container = utils.getContainer();
        //     					const project = utils.latLngToLayerPoint;
        //     					const renderer = utils.getRenderer();
        //     					const getScale = utils.getScale
        //     					const invScale = 1 / getScale();
        
        //     					let zoomChangeTs = null;
        
        //     					console.log(`event type = ${event.type}`);
        //     					if (event.type === 'add') {
        //     						console.log('added to map');
        //     						initialScale = invScale / 8;
        //     						innerContainer.localScale = initialScale;
        //     						json.features.forEach(function (f) {
        //     							const coords = f.geometry.coordinates;
        //     							const latlng = map.point_to_wgs84(coords[1], coords[0]);
        
        //     							const pos = project(latlng);
        // //    							const sprite = new PIXI.Sprite();
        // //    							Object.assign(sprite, {
        // //    								x: pos.x,
        // //    								y: pos.y
        // //    							});
        // //    							sprite.scale.set(1 / scale);
        //     							const sprite = {
        //     								x: pos.x,
        //     								y: pos.y,
        //     								interactive: true
        //     							};
        //     							innerContainer.addChild(sprite);
        //     						})
        //     					} else if (event.type === 'zoomanim') {
        //     						console.log('zoomanim')
        //     					} else if (event.type === 'redraw') {
        //     						console.log('redraw')
        //     						const delta = event.delta;
        //     						if (zoomChangeTs !== null) {
        //     							const duration = 17;
        //     							zoomChangeTs += delta;
        //     							constlambda = zoomChangeTs / duration;
        //     							if (lambda > 1) {
        //     								lambda = 1;
        //     								zoomChangeTs = null;
        //     							}
        //     							lambda = easing(lambda);
        //     							innerContainer.localScale = innerContainer.currentScale + lambda * (innerContainer.targetScale - innerContainer.currentScale);
        //     						} else {
        //     							return;
        //     						}
        //     					}
        
        //     					renderer.render(container);
        //     				}, pixiContainer, {
        //     					doubleBuffering: doubleBuffering,
        //     					destroyInteractionManager: true
        // 					});
        //     			})();
        
        //     			pixiLayer.addTo(map);
        
        //     			var ticker = new PIXI.ticker.Ticker();
        //     			ticker.add(function(delta) {
        //     				pixiLayer.redraw({type: 'redraw', delta: delta});
        //     			});
        //     			map.on('zoomstart', function() {
        //     				console.log('zoomstart');
        //     				ticker.start();
        //     			});
        //     			map.on('zoomend', function() {
        //     				console.log('zoomsend');
        //     				ticker.stop();
        //     			});
        //     			map.on('zoomanim', function () {
        //     				console.log('zoomanim');
        //     				return pixiLayer.redraw();
        //     			}, pixiLayer);
        
        //     		});
    },
    
    addLakeMapIcon: function (feature) {
        if (typeof feature === 'undefined' || feature == null) {
            return;
        }
        var map = this;
        let north = parseFloat(feature.north), east = parseFloat(feature.east);
        
        
        if (isNaN(north) || isNaN(east)) {
            return;
        }
        
        var latlng = map.point_to_wgs84(north, east);
        var m = L.marker(latlng, { icon: this.mapIcon, sjoid: feature.sjoid });
        this.mapMarkers.addLayer(m);
    },
    
    point_to_wgs84: function (north, east) {
        var map = this;
        return map.options.crs.projection.unproject(new L.Point(east, north));
    }
});

export { SvarMap };
